<template>
  <div>
    <!--已报名-->
    <div v-if="isSign">
      <p class="tct fs24" style="color: #337ab7">网上报名信息查看</p>
      <table id="dynamic-table" class="table table-striped table-bordered table-hover"
             style="margin-bottom: 0px;">
        <tbody>
        <tr>
          <td>姓名：</td>
          <td><span class="styleRed" id="xm">{{info.name}}</span></td>
          <td class="styleRed" colspan="2">关键信息，请仔细核对</td>
        </tr>
        <tr>
          <td>性别：</td>
          <td><span style="font-weight: bold;" id="xbdm">
          {{info.sex==1?'男':'女'}}
        </span></td>
          <td>出生年月：</td>
          <td><span style="font-weight: bold;" id="csrq">{{info.date_time}}</span></td>
        </tr>
        <tr>
          <td>民族：</td>
          <td><span style="font-weight: bold;" id="mzdm">{{info.mz}}</span></td>
          <td>是否工作：</td>
          <td><span style="font-weight: bold;" id="zzmmdm">
          {{info.is_gz==1?'是':'否'}}
        </span></td>
        </tr>
        <tr>
          <td>文化程度：</td>
          <td ><span style="font-weight: bold;" id="whcddm">{{info.xueli}}</span></td>
          <!--<td>工作时间：</td>-->
          <!--<td><span style="font-weight: bold;" id="gzrq">2018-06-01</span></td>-->
        </tr>
        <tr>
          <td>证件类型：</td>
          <td><span style="font-weight: bold;" id="zjlxdm">身份证</span></td>
          <td>证件号码：</td>
          <td><span style="font-weight: bold;" id="sfzh">{{info.idcard}}</span></td>
        </tr>
        <tr>
          <td>联系电话：</td>
          <td><span style="font-weight: bold;" id="yddh">{{info.tel}}</span></td>
          <td>电子邮箱：</td>
          <td><span style="font-weight: bold;" id="yzbm">{{info.email}}</span></td>
        </tr>
        <tr>
          <td>通知书邮寄地址：</td>
          <td colspan="3"><span style="font-weight: bold;" id="txdz">{{info.email_address}}</span></td>
        </tr>
        <tr>
          <td>报考层次：</td>
          <td>
            <!--<a href="bmxz.jsp#chapter4" target="_blank" title="请点击查看该层次考试科目情况">
                <span style="font-weight: bold;" th:text="${cc}"></span>
            </a>-->
            <span style="font-weight: bold;" id="ccdm" v-if="info.bk_xl==1">高起专</span>
            <span style="font-weight: bold;" id="ccdm" v-if="info.bk_xl==2">高起本</span>
            <span style="font-weight: bold;" id="ccdm" v-if="info.bk_xl==3">专升本</span>
          </td>
          <td>报考科类：</td>
          <td>
            <!--<a href="bmxz.jsp#chapter4" target="_blank" title="请点击查看该科类考试科目情况">
                <span style="font-weight: bold;" th:text="${kl}"></span>
            </a>-->
            <span style="font-weight: bold;" id="">{{info.xk}}</span>
          </td>
        </tr>
        <!--<tr>-->
        <!--  <td>考试科目：</td>-->
        <!--  <td colspan="3">-->
        <!--    <span style="font-weight: bold;">政治,外语,高等数学(一)</span>-->
        <!--  </td>-->
        <!--</tr>-->
        <tr>
          <td>报考专业：</td>
          <td>
            <span style="font-weight: bold;" id="">{{info.zhuanye_id}}</span>
          </td>
          <td>报考学校名称：</td>
          <td><span style="font-weight: bold;" id="zy1yxdh">{{info.school_id}}</span></td>
        </tr>
        <tr>
          <td>确认地点：</td>
          <td>
            <span style="font-weight: bold;">{{info.qr_address}}</span>
          </td>
          <td>考试地点：</td>
          <td>
            <span style="font-weight: bold;">{{info.ks_address}}</span>
          </td>
        </tr>


        <!--<tr>
          <td>报名确认时间及地点：</td>
          <td colspan="1"><span style="font-weight: bold;">20210809</span></td>
          <td>考试地区：</td>
          <td colspan="1"><span style="font-weight: bold;">山东省济南市历下区</span></td>
        </tr>-->
        <!--<tr>
          <td>网上缴纳报名费：</td>
          <td colspan="3">
            <span>&lt;!&ndash; 未缴费 &ndash;&gt;
              &lt;!&ndash;<span style="font-weight: bold;" th:text="'尚未缴费，应缴纳报考费'+${jfje}+'元；考试网上缴费时间：'+${#servletContext.getAttribute('JFSJTS')}"></span>&ndash;&gt;
                <span style="font-weight: bold;">尚未缴费，应缴纳报考费130元</span>
            </span>
          </td>
        </tr>-->

        </tbody>
      </table>
    </div>
    <!--未报名-->
    <div v-else class="difcc" style="height: 65vh;">
      <el-result icon="info" title="尚未报名" subTitle="点击前往报名">
        <div slot="extra" class="difcc">
          <el-button type="primary" @click="goSign()">去报名</el-button>
        </div>
      </el-result>
    </div>
  </div>
</template>

<script>
export default {
  name: "checkInfo",
  data() {
    return {
      isSign: false,
      info: {
        id: '',
        name: '',
        mz: '',
        sex: '',
        is_gz: '',
        date_time: '',
        idcard: '',
        tel: '',
        address: '',
        email: '',
        email_address: '',
        xueli: '',
        bk_xl: '',
        zhuanye_id: '',
        school_id: '',
        ks_address: '',
        qr_address: '',
        password: '',
        teacher: '',
        image: '',
        add_time: '',
        member_id: '',
        xk: '',
        status: '',
      },
    }
  },
  methods: {
    goSign() { //去报名
      this.$router.push('/infoCenter/sign').catch(err => err)
    },
    getSignInfo() { //获取报名信息
      let user_id = JSON.parse(localStorage.getItem('jiaoyu')).id
      this.$axios("POST","/index/bmUser",{user_id: user_id},'加载中')
      .then(res => {
        if(res.code===1) {
          this.isSign = true
          this.info = res.data
        }
      })
    },
  },
  created() {
    this.getSignInfo();
  }
}
</script>

<style scoped>
  .styleBlue {
    COLOR: #0000FF; FONT-WEIGHT: bold
  }
  .styleRed {
    COLOR: #FF0000; FONT-WEIGHT: bold
  }
  .styleBlack {
    COLOR: #000000; FONT-WEIGHT: bold
  }
</style>